import React from 'react';
import { ChevronLeft } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const BlogPostPage = ({
  selectedPost,
  setSelectedPost,
  setCurrentPage,
  goToLeaderboard,
  mobileMenuOpen,
  setMobileMenuOpen
}) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const handleBackClick = () => {
    setSelectedPost(null);
    window.scrollTo(0, 0);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 via-purple-600 to-purple-800 overflow-x-hidden flex flex-col">
      <Header 
        setCurrentPage={setCurrentPage} 
        goToLeaderboard={goToLeaderboard}
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
      />
      <div className="flex-1 pt-20 p-4">
        <div className="max-w-4xl mx-auto">
          <button
            onClick={handleBackClick}
            className="flex items-center gap-2 text-white hover:text-gray-200 mb-6 transition-colors"
          >
            <ChevronLeft size={20} />
            <span className="font-medium">Back to Blog</span>
          </button>
          
          <article className="bg-white rounded-2xl shadow-2xl p-6 sm:p-8 md:p-12">
            <header className="mb-8 border-b pb-6">
              <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
                {selectedPost.title}
              </h1>
              <time className="text-gray-600 text-sm">
                {formatDate(selectedPost.date)}
              </time>
            </header>
            
            <div 
              className="prose prose-lg max-w-none"
              dangerouslySetInnerHTML={{ __html: selectedPost.content }}
            />
          </article>
        </div>
      </div>
      <div className="h-32"></div>
      <Footer setCurrentPage={setCurrentPage} goToLeaderboard={goToLeaderboard} />
    </div>
  );
};

export default BlogPostPage;